module.exports = __webpack_public_path__ + "static/media/portrait4.63d4cc71.jpg";